"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetServerTime = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var product_1 = require("../../model/product");
var service_1 = require("../../../library/base/service");
var GetServerTime = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetServerTime, _super);
    function GetServerTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取服务器最新交易时间';
        _this.code = '101040';
        _this.desc = '获取服务器最新交易时间';
        _this.requestParams = new product_1.GetServerTimeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetServerTime;
}(service_1.BaseService));
exports.GetServerTime = GetServerTime;
//# sourceMappingURL=getServerTime.js.map